export const AVAILABILITY_OPTIONS = [
  {
    value: 1,
    label: "All interviewers must be available"
  },
  {
    value: 0,
    label: "At least one interviewer must be available"
  }
];
